export const Close = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      {' '}
    <path
      d="M12.0002 9.92905L8.17915 13.75C7.76515 14.164 7.09315 14.164 6.67915 13.75C6.26515 13.336 6.26515 12.664 6.67915 12.25L11.2932 7.63605C11.6842 7.24505 12.3172 7.24505 12.7072 7.63605L17.3212 12.25C17.7352 12.664 17.7352 13.336 17.3212 13.75C16.9072 14.164 16.2352 14.164 15.8212 13.75L12.0002 9.92905Z"
      fill="#F70763"
    />
  </svg>
)
